<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
    style="z-index: 11"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100(style="z-index: 20")
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .h-100.overflow-hidden(
      style="padding-top: 60px!important;"
    )
      .content.h-100(
        style="padding-bottom: 70px;"
      )
        .row.no-gutters.pt-4.px-3(
          style="border-bottom: 0.2rem solid #000;"
        )
          .col-6.px-2
            b-button.position-relative.font-weight-bold.tab_style(
              :class="{ 'active' : selectType === 'backend'}",
              block,
              @click="changeTypeHandler('backend')",
              style="border-radius: .8rem .8rem 0 0;"
            )
              h6.font-weight-bold.mb-0 官方帳號建立
          .col-6.px-2
            b-button.position-relative.font-weight-bold.tab_style(
              :variant="selectType === 'ba' ? 'primary' : 'gray-light-3 text-black'",
              block,
              @click="changeTypeHandler('ba')",
              style="border-radius: .8rem .8rem 0 0;"
            )
              h6.font-weight-bold.mb-0 美容顧問建立
        .mb-2.px-3.pt-3.h-100.overflow-auto(
          style="padding-bottom: 80px;"
        )
          .search-area.row.mx-0.px-3(v-if="selectType === 'backend'")
              .col.px-0.d-flex.align-items-center.pr-2
                el-cascader.w-100(
                  v-model="typeValue",
                  :options="selectedType",
                  clearable,
                  placeholder="模板分類",
                )
              .col.px-0.d-flex.align-items-center
                el-input.w-100(
                  v-model="searchName",
                  clearable,
                  placeholder="模板名稱"
                )
              .col-auto.pl-2.pr-0
                button.btn.btn-block.btn-remind.font-weight-bold.btn-custom.px-3(
                  type="button",
                  @click="searchHandler"
                  style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
                  ) 搜尋
          .text-right
            b-button.text-black(
              variant="remind",
              @click="createTempTextHandler()",
              v-if="selectType === 'ba'",
              style="border: 0.3rem solid #000;border-radius: 9487px;padding: 5px 20px;box-shadow: 0.2rem 0.2rem 0 #00000033;font-weight: bold;"
            ) ＋新增訊息模板
          template(
            v-for="(temp,index) in temps"
          )
            text-input(
              v-if='temp.push_format.type === "text"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :tempTypes="temp_types",
              :selectMode="true",
              :selectTemps="selectTemps",
              :editMode="temp.type === 'ba'"
              @selectTempHandler="selectTempHandler",
              @editTempHandler="editTempHandler",
              @deleteTempHandler="deleteTempHandler"
            )
            image-map-input(
              v-if='temp.push_format.type === "imageMap"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :tempTypes="temp_types",
              :selectMode="true",
              :selectTemps="selectTemps",
              @selectTempHandler="selectTempHandler"
            )
            carousel-input(
              v-if='temp.push_format.type === "carousel"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :tempTypes="temp_types",
              :selectMode="true",
              :selectTemps="selectTemps",
              @selectTempHandler="selectTempHandler"
            )
            video-input(
              v-if='temp.push_format.type === "video"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :tempTypes="temp_types",
              :selectMode="true",
              :selectTemps="selectTemps",
              @selectTempHandler="selectTempHandler"
            )
            image-input(
              v-if='temp.push_format.type === "image"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :tempTypes="temp_types",
              :selectMode="true",
              :selectTemps="selectTemps",
              @selectTempHandler="selectTempHandler"
            )
          infinite-loading(
            @infinite="infiniteHandler",
            :identifier="infiniteId",
            spinner="bubbles",
            ref="infiniteLoading"
          )
            .cursor-default.mt-3(slot="no-more") 無更多模板
            .cursor-default.mt-3(slot="no-results") 無更多模板
            .cursor-default.mt-3(slot="error") 發生錯誤，請重整重試一次
    .position-fixed.w-100.modal_footer(
      style="bottom: 0px;height: 70px;z-index: 3;"
    )
      .row.justify-content-center.align-items-center.h-100
        .col-6
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="previewHandler()",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;"
          ) 發送
    //- 前台模板新增 - 文字
    tempTextModel(
      title="新增訊息模板",
      Zindex='20px',
      :modelCSS="tempModelCSS",
      @scrollToTarget="scrollToTarget",
      @changeTypeHandler="changeTypeHandler"
    )

    //- 發送預覽
    tempSendPreviewModel(
      title="確認要發送此訊息嗎？",
      :modelCSS="tempSendPreviewCSS",
      :previewTemps="selectTemps",
      Zindex='10',
      :user="user"
      :multicastPush="multicastPush",
      :users="users",
      @scrollToTarget="scrollToTarget",
      @closeModelHandler="closeModel"
      ref='tempSendPreviewModel'
    )

</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';
import tempTextModel from '@/components/customerModel/tempTextModel.vue';
import tempSendPreviewModel from '@/components/customerModel/tempSendPreviewModel.vue';

// 模板顯示部分
import textInput from '@/components/modalTemplate/messageText/textInput.vue';
import imageMapInput from '@/components/modalTemplate/messageImageMap/imageMapInput.vue';
import carouselInput from '@/components/modalTemplate/messageCarousel/carouselInput.vue';
import videoInput from '@/components/modalTemplate/messageVideo/videoInput.vue';
import imageInput from '@/components/modalTemplate/messageImage/imageInput.vue';

const _ = require('lodash');

export default {
  name: 'TempModel',
  components: {
    InfiniteLoading,
    tempTextModel,
    tempSendPreviewModel,
    textInput,
    imageMapInput,
    carouselInput,
    videoInput,
    imageInput,
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: [Object, null],
      default: null
    },
    multicastPush: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      selectType: "backend",
      selectTemps: [], // 選擇的模板
      selectedType: [],
      typeValue: null,
      searchName: "",
      tempModelCSS: {}, // 新增訊息模板的 CSS
      tempSendPreviewCSS: {
        top: 0,
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: '3rem !important',
        borderRadius: '15px',
        display: 'flex'
      },// 訊息模板預覽的 CSS
      infiniteId: +new Date(),
      windowScrollHeight: 0 // 視窗原本位置
    };
  },
  mounted() {
    this.$EventBus.$on('openTempModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 初始化
      vm.selectTemps = [];
      vm.$store.commit('sa_temp/resetInfiniteLoadingData');

      vm.$swal.close();
      vm.openModel();
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;
      if (!vm.showModel) return;

      let apiTarget;

      switch (vm.selectType) {
        case 'ba':
          apiTarget = 'getTemplatesHandler';
          break;
        case 'backend':
          apiTarget = 'getTemplatesAdminHandler';
          break;
        default:
          break;
      }

      if (!vm.selectType || !apiTarget) {
        vm.$swal.fire({
          icon: 'error',
          title: '編輯目標錯誤[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store
        .dispatch(`sa_temp/${apiTarget}`, {
          current_page: parseInt(vm.pagination.current_page) + 1,
          per_page: parseInt(vm.pagination.per_page),
          templates_type_id: vm.typeValue,
          name: vm.searchName,
        })
        .then(() => {
          const vm = this;
          if (vm.pagination.current_page != vm.pagination.total_page) {
            $state.loaded();
          } else {
            $state.complete();
          }
          if (vm.temp_types) {
            vm.selectedType = [
              { value: null, label: "All" },
              ...vm.temp_types.map((type) => ({ value: type.id, label: type.name })),
            ];
          }
        });
    },
    searchHandler() {
      this.$store.commit("sa_temp/resetInfiniteLoadingData");
      this.infiniteId += 1;
    },
    // 選擇模板
    selectTempHandler({ id, template }) {
      const vm = this;
      const selectTemps_key = _.findKey(vm.selectTemps, (val) => val.id === id && val.type === template);
      if (selectTemps_key) {
        vm.selectTemps.splice(selectTemps_key, 1);
      } else {
        const temps_key = _.findKey(vm.temps, (val) => val.id === id && val.type === template);
        if (temps_key) {
          vm.selectTemps.push(vm.temps[temps_key]);
        }
      }
    },
    // 編輯模板
    async editTempHandler({ id }) {
      const vm = this;
      const key = _.findKey(vm.temps, (val) => val.id === id);
      if (key && vm.temps[key].push_format.type === 'text') {
        vm.windowScrollHeight = $('#CustomerTempModel').scrollTop();
        await vm.scrollToTop();
        vm.$EventBus.$emit('openTempTextModel', vm.temps[key]);
      }
    },
    // 刪除模板
    deleteTempHandler({ id }) {
      const vm = this;
      vm.$swal.fire({
        title: '您確定刪除訊息模板?',
        text: '刪除後模板無法復原！',
        html: '請注意，刪除後將<span style="color: #d33">無法回覆</span>該訊息模板',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'custom-swal-btn',
          cancelButton: 'custom-swal-btn'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '訊息模板刪除中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          // 解除綁定
          vm.$store.dispatch('sa_temp/deleteTempHandler', id)
            .then(() => {
              const key = _.findKey(vm.selectTemps, (val) => val.id === id);
              vm.selectTemps.splice(vm.selectTemps[key], 1);
              vm.changeTypeHandler(vm.selectType);
              vm.$swal.close();
            });
        }
      });
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$refs.tempSendPreviewModel.closeModel();
      this.$emit('closeModelHandler');
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    changeTypeHandler(type = this.selectType) {
      const vm = this;
      vm.$store.commit('sa_temp/resetInfiniteLoadingData');
      vm.selectType = type;
      vm.infiniteId += 1;
    },
    // 開啟新增訊息模板彈窗
    async createTempTextHandler() {
      const vm = this;
      vm.windowScrollHeight = $('#CustomerTempModel').scrollTop();
      await vm.scrollToTop();
      vm.$EventBus.$emit('openTempTextModel');
    },
    // 發送預覽
    async previewHandler() {
      const vm = this;
      if (vm.selectTemps.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '至少需要選擇一則模板'
        });
      } else if (vm.selectTemps.length > 5) {
        vm.$swal.fire({
          icon: 'error',
          title: '單次最多只能發送五則訊息'
        });
      } else {
        vm.windowScrollHeight = $('#CustomerTempModel').scrollTop();
        await vm.scrollToTop();
        vm.$EventBus.$emit('openTempSendPreviewModel');
      }
    },
    // 把視窗移到最頂部
    scrollToTop() {
      return new Promise((resolve) => {
        if ($('#CustomerTempModel').scrollTop() === 0) {
          resolve();
        } else {
          $('#CustomerTempModel').animate({
            scrollTop: 0
          }, 500);
        }
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').addClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    // 把視窗移到原本位置
    scrollToTarget() {
      const vm = this;
      return new Promise((resolve) => {
        $('#CustomerTempModel').animate({
          scrollTop: vm.windowScrollHeight
        }, 500);
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').removeClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    async submitHandler() {
      const vm = this;
      const data = await _.map(vm.selectTemps, (val) => ({
        id: val.id,
        template: val.type,
        text: val.push_format.type === 'text' ? val.push_format.text : null
      }));

      if (vm.selectTemps.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '至少需要選擇一則模板'
        });
      } else if (vm.selectTemps.length > 5) {
        vm.$swal.fire({
          icon: 'error',
          title: '單次最多只能發送五則訊息'
        });
      } else {
        vm.$swal.fire({
          title: '模板送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        let sendData;

        // 群發
        if (vm.multicastPush) {
          sendData = {
            to: _.map(vm.users, (val) => val.member_line_uuid || val.line_uuid),
            templates: data
          };
        } else if (!vm.multicastPush) {
          sendData = {
            member_uuid: vm.user.member_uuid,
            templates: data
          };
        } else {
          return;
        }

        vm.$store.dispatch(`sa_chat/${vm.multicastPush ? 'templatesMulticastPushHandler' : 'templatesPushHandler'}`, sendData)
          .then(() => {
            vm.closeModel();
            vm.$swal.close();
          });
      }
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openTempModel');
  },
  computed: {
    ...mapState({
      temps: (state) => state.sa_temp.temps,
      temp_types: (state) => state.sa_temp.temp_types,
      pagination: (state) => state.sa_temp.pagination
    })
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "icon";
  src: url("../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.2rem;
  margin-bottom: 4px;
}

.iconClose:before {
  content: "\e908";
}
</style>
